// @module Tavanoteam.PLPBackorderMessage.PLPBackorderMessage
define('Tavanoteam.PLPBackorderMessage.BackOrderMessageModal.View',
	['tavanoteam_plpbackordermessage_plpbackordermessage_modal.tpl', 'Backbone'],
	function (tavanoteam_plpbackordermessage_plpbackordermessage_modal_tpl, Backbone) {
		'use strict';
		return Backbone.View.extend({

			template: tavanoteam_plpbackordermessage_plpbackordermessage_modal_tpl

			, initialize: function (options) {
				Backbone.View.prototype.initialize.apply(this, arguments);
				this.item = options.item;
				console.log(options)
			}

			, events: {
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return Tavanoteam.PLPBackorderMessage.PLPBackorderMessage.View.Context
			, getContext: function getContext() {
				var itemBackorderMessage = this.item.outofstockmessage || SC.CONFIGURATION.TT.bkordermessage || "";
				return {
					itemBackorderMessage: itemBackorderMessage
				};
			}
		});
	});
